import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { deleteDesplazamientoTarea, deleteExtraTarea, eliminarComentarioTarea as eliminarComentarioTareaApi, getTarea, postComentarioTarea, postComentarioTareaInter, verificarToken } from '../../../services/apis';
import { useNavigate, useParams } from 'react-router-dom';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import logoempresa from '../../../media/logoempresa.png';
import { RegistroAccionesCard } from '../../../utils/componentes-utiles/RegistroAccionesCard';
import { BarrasHorasSemanaEmpleado } from '../../../utils/componentes-utiles/graficas/BarrasHorasSemanaEmpleado';
import { BarrasHorasInvertidasTarea } from '../../../utils/componentes-utiles/graficas/BarrasHorasInvertidasTarea';
import { ChatInterno } from './ChatInterno';
import { convertirEnlaces, textoMayusculas } from '../../../utils/utils';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


export const TareaDialog = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, setHorasTotales, setPausarRecargaTareas }) => {

    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };
    const [tarea, setTarea] = useState(tareaInfo);

    //aux
    const mensajePorDefecto = [{
        autor: "3",
        color: "7303fc",
        comentario: "Escribe un Comentario",
    }];
    //utils
    const [comentarios, setComentarios] = useState([]);
    const [comentariosInternos, setComentariosInternos] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [mensajeInterno, setMensajeInterno] = useState('');
    const [tareaAcciones, setTareaAcciones] = useState([]);
    const [extras, setExtras] = useState([]);
    const [desplazamientos, setDesplazamientos] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [puedeEliminarComentarios, setPuedeEliminarComentarios] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [comentarioAEliminar, setComentarioAEliminar] = useState(null);
    const [datoshoras, setDatosHoras] = useState([
        {
            "dia": "M1/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 43,

                    "horas": 0.5
                },
                {
                    "usuario": "Jorge Sanchez",
                    "id": 32,

                    "horas": 1.75
                }
            ]
        },
        {
            "dia": "X2/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 433,

                    "horas": 0.5
                },
                {
                    "usuario": "Cristian Garcia",
                    "id": 53,

                    "horas": 3.5
                }
            ]
        },
        {
            "dia": "V4/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 3,
                    "horas": 0.25
                },
                {
                    "usuario": "Ivan Aguilar",
                    "id": 2,
                    "horas": 2.5
                },
                {
                    "usuario": "Jorge Sanchez",
                    "id": 1,
                    "horas": 2
                }
            ]
        },

    ]);
    const [chats, setChats] = useState([])

    const param = useParams();



    const handleInputChange = (event) => {
        setMensaje(event.target.value);
    };
    const handleInputChangeInterno = (event) => {
        setMensajeInterno(event.target.value);
    };

    const handleKeyPress = (event) => {
        console.log(event.target.name);

        if (event.target.name === 'mensaje') {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentario();
            }
        } else {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentarioInterno();
            }
        }
    };


    const cargarTareas = async () => {
        try {
            const response = await getTarea(tarea.id_proyecto, tarea.id, 2);
            const responseSesion = await verificarToken();
            setPuedeEliminarComentarios(String(responseSesion?.rol) === '986');
            setComentarios(response.data.comentarios.length > 0 ? response.data.comentarios : mensajePorDefecto);
            setComentariosInternos(response.data.comentarios_internos.length > 0 ? response.data.comentarios_internos : mensajePorDefecto);
            setTareaAcciones(response.data.acciones);
            setExtras(response.data.extras?.length > 0 ? response.data.extras : []);
            setDesplazamientos(response.data.desplazamientos?.length > 0 ? response.data.desplazamientos : []);
            setDatosHoras(response.data.tareas_agrupadas ? response.data.tareas_agrupadas : []);
            setChats(response.data.chats)
            // setOpciones(response.data.opcionesTareas);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }

    const abrirConfirmacionEliminar = (comentario) => {
        setComentarioAEliminar(comentario);
        setOpenConfirmDelete(true);
    };

    const cerrarConfirmacionEliminar = () => {
        setOpenConfirmDelete(false);
        setComentarioAEliminar(null);
    };

    const confirmarEliminarComentario = async () => {
        if (!comentarioAEliminar?.id) return;

        await eliminarComentario(comentarioAEliminar.id);
        cerrarConfirmacionEliminar();
    };

    const eliminarComentario = async (idComentario) => {
        try {
            const response = await eliminarComentarioTareaApi(idComentario);

            if (response?.success) {
                setComentarios((prev) => prev.filter((comentario) => String(comentario.id) !== String(idComentario)));
                setComentariosInternos((prev) => prev.filter((comentario) => String(comentario.id) !== String(idComentario)));
                cargarTareas();
            }
        } catch (error) {
            console.error("Error al eliminar el comentario:", error);
        }
    }



    const enviarComentario = async () => {

        if (mensaje != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensaje,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTarea(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensaje('')
            cargarTareas()
        }

    }

    const enviarComentarioInterno = async () => {

        if (mensajeInterno != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensajeInterno,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTareaInter(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensajeInterno('')
            cargarTareas()
        }

    }

    useEffect(() => {
        if (open === true) {
            cargarTareas();
        }
    }, [open])


    const calcularTotalHorasFormateado = (diasEditados) => {
        const totalDecimal = diasEditados.reduce((total, dia) => {
            return total + dia.tareas.reduce((sum, tarea) => sum + (tarea.horas || 0), 0);
        }, 0);

        const horas = Math.floor(totalDecimal);
        const minutos = Math.round((totalDecimal - horas) * 60);

        setHorasTotales(`${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`)
        return `${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`;
    };

    const precioTotalExtras = (extras) => {
        return extras.reduce((total, extra) => total + Number(extra.precio || 0), 0);
    };

    const totalDesplazamientos = (desplazamientos) => {
        return desplazamientos.reduce((total, desplazamiento) => total + parseInt(desplazamiento.cantidad || 0, 10), 0);
    };

    const normalizarTelefonoWhatsapp = (telefono) => {
        let telefonoLimpio = String(telefono || '').replace(/\D/g, '');

        if (telefonoLimpio.startsWith('00')) {
            telefonoLimpio = telefonoLimpio.slice(2);
        }

        if (telefonoLimpio.length === 9) {
            return `34${telefonoLimpio}`;
        }

        return telefonoLimpio;
    };

    const formatearMinutos = (minutosTotales) => {
        const total = Number(minutosTotales || 0);
        const horas = Math.floor(total / 60);
        const minutos = total % 60;

        return `${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`;
    };

    const eliminarExtra = async (idExtra) => {
        if (!idExtra) return;

        try {
            const response = await deleteExtraTarea(idExtra, tarea.id);

            if (response?.success) {
                setExtras(response.data);
            }
        } catch (error) {
            console.error("Error al eliminar el extra:", error);
        }
    };

    const eliminarDesplazamiento = async (idDesplazamiento) => {
        if (!idDesplazamiento) return;

        try {
            const response = await deleteDesplazamientoTarea(idDesplazamiento, tarea.id);

            if (response?.success) {
                setDesplazamientos(response.data);
            }
        } catch (error) {
            console.error("Error al eliminar el desplazamiento:", error);
        }
    };

    const opcionesChats = {
        ChatInterno: <ChatInterno
            comentariosInternos={comentariosInternos}
            enviarComentario={enviarComentario}
            mensajeInterno={mensajeInterno}
            handleInputChangeInterno={handleInputChangeInterno}
            handleKeyPress={handleKeyPress}
            enviarComentarioInterno={enviarComentarioInterno}
            puedeEliminarComentarios={puedeEliminarComentarios}
            eliminarComentarioInterno={eliminarComentario}
        >
        </ChatInterno>,
    }

    const telefonoCliente = tareaInfo.telefono_cliente || tareaInfo.telefono;
    const telefonoWhatsapp = normalizarTelefonoWhatsapp(telefonoCliente);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth='xl'
        >

            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minWidth: '90%'
            }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mb: 3 }}
                    >
                        <Grid
                            container
                            xs={8}
                            justifyContent="start"
                            alignItems="start"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                                maxHeight: '10vh',
                            }}
                        >
                            <Typography variant='h5'>
                                {tareaInfo.id}
                            </Typography>

                            <Typography variant='h4'>
                                {tarea.asunto}
                            </Typography>
                        </Grid>

                        <CancelIcon variant='contained' className='pointer' onClick={handleClose}></CancelIcon>
                    </Grid>

                    <Typography variant='subtitle1'>
                        <strong> Cliente: </strong> {textoMayusculas(tarea.cliente)}
                    </Typography>

                    {tareaInfo.correo && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs="auto"
                            gap={1}
                        >
                            <Typography variant="subtitle1">
                                <strong>Correo: </strong>{tareaInfo.correo}
                            </Typography>

                            <Tooltip title="Enviar correo" arrow>
                                <IconButton
                                    size="small"
                                    color="primary"
                                    component="a"
                                    href={`mailto:${tareaInfo.correo}`}
                                >
                                    <EmailIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    )}

                    {telefonoWhatsapp && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs="auto"
                            gap={1}
                        >
                            <Typography variant="subtitle1">
                                <strong>Telefono: </strong>{telefonoCliente}
                            </Typography>

                            <Tooltip title="Abrir WhatsApp" arrow>
                                <IconButton
                                    size="small"
                                    color="success"
                                    component="a"
                                    href={`https://wa.me/${telefonoWhatsapp}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsAppIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    )}

                    <Typography variant='h5'>
                        <strong> Descripción:</strong> {tarea.descripcion}
                    </Typography>
                    {extras.length > 0 && (
                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12}
                            sx={{ mt: 2 }}
                        >
                            <Divider variant="fullWidth" sx={{ minWidth: '100%', mb: 1 }} />

                            <Typography variant='h6'>
                                Articulos extra
                            </Typography>

                            <Grid
                                container
                                direction="column"
                                justifyContent="start"
                                alignItems="start"
                                xs={12}
                                gap={1}
                            >
                                {extras.map((ext, index) => (
                                    <Grid
                                        key={ext.id || index}
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        xs={12}
                                        className='articulo-extra'
                                        sx={{ p: 1 }}
                                    >
                                        <Typography variant='subtitle1' color="text.primary">
                                            {ext.descripcion}
                                        </Typography>

                                        <Typography variant='subtitle1' color="text.primary">
                                            Precio: <strong>{ext.precio}€</strong>
                                        </Typography>
                                        <Tooltip title="Eliminar articulo extra" arrow>
                                            <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() => eliminarExtra(ext.id)}
                                            >
                                                <DeleteForeverIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                ))}
                            </Grid>

                            <Typography variant='subtitle1' sx={{ mt: 1 }}>
                                <strong>Total articulos extra: </strong>{precioTotalExtras(extras)}€
                            </Typography>
                        </Grid>
                    )}
                    {desplazamientos.length > 0 && (
                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12}
                            sx={{ mt: 2 }}
                        >
                            <Divider variant="fullWidth" sx={{ minWidth: '100%', mb: 1 }} />

                            <Typography variant='h6'>
                                Desplazamientos
                            </Typography>

                            <Grid
                                container
                                direction="column"
                                justifyContent="start"
                                alignItems="start"
                                xs={12}
                                gap={1}
                            >
                                {desplazamientos.map((desplazamiento, index) => (
                                    <Grid
                                        key={desplazamiento.id || index}
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        xs={12}
                                        className='articulo-extra'
                                        sx={{ p: 1 }}
                                    >
                                        <Typography variant='subtitle1' color="text.primary">
                                            {desplazamiento.comentario}
                                        </Typography>

                                        <Typography variant='subtitle1' color="text.primary">
                                            Cantidad: <strong>{parseInt(desplazamiento.cantidad || 0, 10)}</strong>
                                        </Typography>
                                        <Tooltip title="Eliminar desplazamiento" arrow>
                                            <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() => eliminarDesplazamiento(desplazamiento.id)}
                                            >
                                                <DeleteForeverIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                ))}
                            </Grid>

                            <Typography variant='subtitle1' sx={{ mt: 1 }}>
                                <strong>Total desplazamientos: </strong>{totalDesplazamientos(desplazamientos)}
                            </Typography>
                        </Grid>
                    )}
                    <Grid container xs={12} >
                        <BarrasHorasInvertidasTarea data={datoshoras} id_tarea={tareaInfo.id} cargarTareas={cargarTareas} setPausarRecargaTareas={setPausarRecargaTareas}></BarrasHorasInvertidasTarea>

                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mt: 2 }}
                    >
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="subtitle1">
                                {/* <strong> Horas empleadas: </strong>
                                {`${Math.floor(tareaInfo.minutos / 60)}h ${tareaInfo.minutos % 60}m`}<br></br> */}
                                <strong> Horas empleadas: </strong>

                                {calcularTotalHorasFormateado(datoshoras)}
                            </Typography>
                            {Number(tareaInfo.minutos_estimados || tarea.minutos_estimados || 0) > 0 && (
                                <Typography variant="subtitle1">
                                    <strong> Horas estimadas: </strong>
                                    {formatearMinutos(tareaInfo.minutos_estimados || tarea.minutos_estimados)}
                                </Typography>
                            )}
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="start"
                            xs={12} md={3.5}
                        >
                            {tareaInfo.trabajadores.length > 0 && (
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                    <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                        <Typography variant="subtitle1" gutterBottom>
                                            <strong> Asignado a:&nbsp;</strong>
                                            {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                                <span>{textoMayusculas(trabajador.label)}&nbsp;</span>
                                                // <Grid item xs={12} textAlign={'left'}>
                                                //     <Typography variant="caption" gutterBottom key={index} sx={{ fontWeight: 600 }}>
                                                //         {trabajador.label}&nbsp;
                                                //     </Typography>
                                                // </Grid>
                                            ))}
                                        </Typography>
                                    </Grid>


                                    <>
                                        {tareaInfo.trabajadores.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.trabajadores.length == 0 && (
                                <Grid container xs={12} justifyContent="start" alignItems="center">
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Asignado a: </strong>Sin Asignar
                                    </Typography>
                                </Grid>
                            )}


                        </Grid>


                        <Grid
                            container
                            direction="row"
                            justifyContent="end"
                            alignItems="start"
                            xs={12} lg={3.5}
                        // style={{
                        // minHeight: '15vh',
                        // maxHeight: '35vh',
                        // }}
                        >
                            {tareaInfo.usuarios_con_tiempo.length > 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="start">
                                    <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                        <strong>En curso por:&nbsp;</strong>
                                        {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                            <span>{textoMayusculas(trabajador.label)}&nbsp;</span>
                                        ))}
                                    </Typography>

                                    <>
                                        {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.usuarios_con_tiempo.length == 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="end" >
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>
                                        <strong>En curso por: </strong>Sin Trabajadores En Curso
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>

                                    </Typography>
                                </Grid>
                            )}

                        </Grid>
                    </Grid>

                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    xs={12}
                >
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={3.75}
                    >
                        {comentarios.length > 0 && (
                            <>
                                <div className='envase-chat'>
                                    <strong>&nbsp;Comentarios:</strong>
                                    <div className='contenedor-chat' style={{ minHeight: '25.5vh', maxHeight: '25.5vh', overflow: 'auto' }}>
                                        {comentarios.map((comentario => (

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                alignItems="center"
                                                xs={10}
                                                className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                                                key={comentario.id}
                                            >
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    alignItems="start"
                                                    xs={12}
                                                >
                                                    <Typography variant='subtitle1' sx={{ color: comentario.color, textAlign: 'left' }} >
                                                        <strong>{comentario.nombre}</strong>
                                                    </Typography>
                                                    {puedeEliminarComentarios && comentario.id && (
                                                        <Tooltip title="Eliminar comentario" arrow>
                                                            <IconButton
                                                                size="small"
                                                                color="error"
                                                                onClick={() => abrirConfirmacionEliminar(comentario)}
                                                            >
                                                                <DeleteForeverIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="start"
                                                    alignItems="start"
                                                    xs={12}
                                                >
                                                    <Typography variant='body2' className='texto-con-salto'>
                                                        {convertirEnlaces(comentario.comentario)}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="end"
                                                    alignItems="end"
                                                    xs={12}
                                                >
                                                    <Typography variant='caption'>
                                                        <strong>{comentario.fecha}</strong>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )))}

                                    </div>
                                    <Grid xs={12} className='chat-bar'>
                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                                            variant='outlined'
                                            onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                                        >
                                            <InputBase
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Escribe un mensaje nuevo"
                                                inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                                                value={mensaje}
                                                name='mensaje'
                                                onChange={handleInputChange}
                                                onKeyPress={handleKeyPress}
                                            />
                                            <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                                                <SendIcon onClick={() => enviarComentario()} />
                                            </IconButton>
                                        </Paper>
                                    </Grid>
                                </div>
                            </>
                        )}


                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={3.75}
                    >
                        {/* // comentarios internos */}
                        {chats[0] && (
                            <>
                                {opcionesChats[chats[0].nombre]}
                            </>
                        )}
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12} lg={4}
                    >
                        <RegistroAccionesCard acciones={tareaAcciones} />
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant='inherit'>
                            <strong>Creado por: </strong>{tareaInfo.creador}
                        </Typography>
                    </Grid>

                </Grid>







            </DialogContent>
            {/* <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                {opciones.map((opcion, index) => (
                    <Grid container xs={3} sm={3} md={3} xl={3} gap={1} justifyContent="space-around" alignItems="center">
                        <Button
                            variant='contained'
                            className='button-default'
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            disabled={
                                opcion.id_estado == 4 ? tarea.id_estado != 3 :
                                tarea.id_estado == 3 && opcion.id_estado != 4
                                        ? true
                                        : (tarea.id_estado == 1)
                                            ? (opcion.id_estado == 1)
                                            : (opcion.id_estado == 2)}
                        >
                            {opcion.nombre}
                        </Button>
                    </Grid>

                ))}
            </DialogActions> */}

            <Dialog
                open={openConfirmDelete}
                onClose={cerrarConfirmacionEliminar}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    Eliminar comentario
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ¿Seguro que quieres eliminar este comentario?
                    </Typography>

                    {comentarioAEliminar?.comentario && (
                        <Typography
                            variant="body2"
                            sx={{
                                p: 1.5,
                                backgroundColor: '#f5f5f5',
                                color: '#000',
                                borderRadius: 1,
                                maxHeight: 120,
                                overflow: 'auto'
                            }}
                        >
                            {comentarioAEliminar.comentario}
                        </Typography>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={cerrarConfirmacionEliminar}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={confirmarEliminarComentario}
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

        </Dialog>
    )
}
